import { updates } from "@/mocks/updates";
import type { UpdateItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const data = updates as UpdateItem[];

export default function UpdateSection() {
  return (
    <section id="updates" className="scroll-mt-20 border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="今日更新速览"
          title="刚上线与刚更新的资源，一眼扫完"
          desc="下面这批是本次抓取到的最新动态，包含跟播剧集的新集数、补档纪录片与电影修复版。先看这里能快速判断有没有值得马上开看的作品。"
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {data.map((item) => (
            <article
              key={item.id}
              className="flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
                  {item.type}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  {item.time}
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="text-sm text-foreground-700">{item.info}</p>
              <div className="mt-auto flex items-center gap-2 border-t border-background-200/70 pt-3">
                <i className="ri-folder-download-line text-secondary-600"></i>
                <span className="text-xs text-secondary-700">{item.quality}</span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          说明：更新时间为本次整理时的相对时间，用于判断资源新鲜度；具体集数以条目内标注的进度为准。
        </p>
      </div>
    </section>
  );
}